<!-- eslint-disable -->
<script>
import Wink from "@/components/illustrations/Wink";
import Brush from "@/components/illustrations/Brush";
import Arrow from "@/components/Arrow";

import Avatar from "@/components/Avatar"

export default {
  name: "IntroHero",
  components: {
    Wink,
    Arrow,
    Brush,
    Avatar
  },
  props: {
    reverse: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ""
    },
    description: {
      type: String,
      default: ""
    }
  }
};
</script>

<template>
  <div class="flex justify-center intro-hero">
    <div class="intro-container">
      <h5 class="intro">初めまして〜 <span>nice to meet you!</span></h5>
      <h1>I am Mai</h1>
      <brush class="brush" />
      <p>
        Research-driven UX designer, which basically gives me more of an excuse to be an even bigger nerd.
      </p>
      <div class="outro">
        {{ $t("intro.palindrome") }} <wink class="emoji" />
      </div>
      <Arrow class="arrow" />
    </div>
    <Avatar />
  </div>
</template>

<style lang="scss">
.intro-hero {
  margin-bottom: 140px;

  .intro-container {
    max-width: 600px;
    position: relative;
  }

  h1 {
    font-family: Lora;
    font-style: normal;
    font-weight: normal;
    font-size: 110px;
    line-height: 102%;

    color: #343434;
    margin-bottom: 24px;
  }

  h5 {
    font-family: Osaka;
    font-style: normal;
    font-weight: normal;
    font-size: 24px;
    line-height: 34px;

    color: #292f33;
    margin-bottom: 16px;
  }

  span {
    font-family: Open Sans;
    font-style: italic;
    font-weight: normal;
    font-size: 24px;
    line-height: 33px;

    color: rgba(41, 47, 51, 0.8);
  }

  p {
    font-family: Open Sans;
    font-style: normal;
    font-weight: normal;
    font-size: 24px;
    line-height: 142.5%;

    color: #595959;
  }

  .arrow {
    position: absolute;
    top: 110px;
    left: -30px;
  }

  .outro {
    margin-top: 37px;
    margin-left: 3px;
  }

  .emoji {
    display: inline;
    margin-left: 6px;
    vertical-align: sub;
  }

  .brush {
    position: absolute;
    top: 50px;
    left: 250px;
  }
}
</style>
